{
  "A project keeps at least one active stream.": "Un projet garde au moins un stream actif.",
  "Active filters": "Filtres actifs",
  "Active projects": "Projets actifs",
  "Add a link": "Ajouter un lien",
  "Add a stream": "Ajouter un stream",
  "Add the stream": "Ajouter le stream",
  "Address": "Adresse",
  "All TRLs": "Tous les TRL",
  "All people": "Toutes les personnes",
  "All statuses": "Tous les statuts",
  "All streams": "Tous les streams",
  "All technologies": "Toutes les technologies",
  "Appoint the TL/PO…": "Nommer les TL/PO…",
  "Archive": "Archiver",
  "Archive stream “{{name}}”?": "Archiver le stream « {{name}} » ?",
  "Archive the stream": "Archiver le stream",
  "Archived": "Archivé",
  "Ask to join": "Demander à rejoindre",
  "Ask to join {{title}}": "Demander à rejoindre {{title}}",
  "Ask to leave": "Demander à quitter",
  "Ask to leave {{title}}": "Demander à quitter {{title}}",
  "Assign": "Affecter",
  "Assign a person": "Affecter une personne",
  "Assign a person…": "Affecter une personne…",
  "Assignment created": "Affectation créée",
  "Assignment deleted": "Affectation supprimée",
  "Assignment finished": "Affectation terminée",
  "Back to active projects": "Revenir aux projets actifs",
  "Back to projects": "Retour aux projets",
  "Cancel": "Annuler",
  "Cancel the assignment": "Annuler l'affectation",
  "Changes to the project and its streams will appear here.": "Les modifications du projet et de ses streams apparaîtront ici.",
  "Choose a stream": "Choisir un stream",
  "Clear filters": "Effacer les filtres",
  "Close permanently": "Clore définitivement",
  "Close the project…": "Clore le projet…",
  "Close “{{title}}”?": "Clore « {{title}} » ?",
  "Closed on": "Clos le",
  "Confirm": "Confirmer",
  "Created on": "Créé le",
  "Date before the start: the assignment will be deleted.": "Date antérieure au début : l'affectation sera supprimée.",
  "Delete the assignment": "Supprimer l'affectation",
  "Description": "Description",
  "Description (optional)": "Description (facultatif)",
  "Description changed": "Description modifiée",
  "Direct assignment to a stream of {{title}}. The person and the TL/PO are notified by email.": "Affectation directe à un stream de {{title}}. La personne et les TL/PO sont prévenus par email.",
  "Edit": "Modifier",
  "Edit the project": "Modifier le projet",
  "End": "Terminer",
  "End the assignment": "Terminer l'affectation",
  "Every assignment ends today (upcoming ones are deleted), pending requests are cancelled and the people concerned are notified by email. A closed project cannot be reopened.": "Toutes les affectations se terminent aujourd'hui (celles à venir sont supprimées), les demandes en attente sont annulées et les personnes concernées prévenues par email. Un projet clos ne se rouvre pas.",
  "Expected address: https://…, git@… or ssh://…": "Adresse attendue : https://…, git@… ou ssh://…",
  "Filter projects": "Filtrer les projets",
  "Filter reports": "Filtrer les comptes rendus",
  "GitHub or GitLab repositories, SharePoint folders, documentation, production… Code repositories also let Claude draft the report from the commits.": "Dépôts GitHub ou GitLab, dossiers SharePoint, documentation, production… Les dépôts de code permettent aussi à Claude de rédiger le CRA à partir des commits.",
  "Headcount": "Effectif",
  "History": "Historique",
  "Included. The person and the TL/PO are notified by email.": "Inclus. La personne et les TL/PO sont prévenus par email.",
  "Internal projects": "Projets internes",
  "Internal projects, their streams and their teams. Ask to join a project from its page.": "Les projets internes, leurs streams et leurs équipes. Demandez à rejoindre un projet depuis sa fiche.",
  "Label (optional)": "Libellé (facultatif)",
  "Last day": "Dernier jour",
  "Leave": "Quitter",
  "Links": "Liens",
  "Links saved": "Liens enregistrés",
  "Loading history…": "Chargement de l'historique…",
  "Loading projects…": "Chargement des projets…",
  "Loading project…": "Chargement du projet…",
  "Loading reports…": "Chargement des comptes rendus…",
  "Manage (DAR)": "Gérer (DAR)",
  "Maturity": "Maturité",
  "Maturity (TRL)": "Maturité (TRL)",
  "Members of stream {{name}}": "Membres du stream {{name}}",
  "Message (optional)": "Message (facultatif)",
  "Minimum TRL": "TRL minimum",
  "My projects": "Mes projets",
  "My status": "Mon statut",
  "New project": "Nouveau projet",
  "New status: {{status}}": "Nouveau statut : {{status}}",
  "New stream": "Nouveau stream",
  "No active project": "Aucun projet actif",
  "No description yet.": "Pas encore de description.",
  "No event": "Aucun événement",
  "No link": "Aucun lien",
  "No link yet. Code repositories are used to draft the report from the commits.": "Aucun lien. Les dépôts de code servent à rédiger le CRA depuis les commits.",
  "No link.": "Aucun lien.",
  "No matching project": "Aucun projet ne correspond",
  "No project answers to the address “{{slug}}”.": "Aucun projet ne répond à l'adresse « {{slug}} ».",
  "No report": "Aucun compte rendu",
  "No report submitted for these filters.": "Aucun compte rendu soumis pour ces filtres.",
  "Nobody is assigned to this project yet.": "Personne n'est encore affecté à ce projet.",
  "Nobody is assigned to this stream.": "Personne n'est affecté à ce stream.",
  "Only assignable people (DAR rule) are offered.": "Seules les personnes assignables (règle de la DAR) sont proposées.",
  "Only the DAR renames a project; the project's address does not change.": "Seule la DAR renomme un projet ; l'adresse du projet ne change pas.",
  "Overview": "Présentation",
  "Pause": "Mettre en pause",
  "Pause “{{title}}”?": "Mettre « {{title}} » en pause ?",
  "Pause…": "Mettre en pause…",
  "Pending requests": "Demandes en attente",
  "People are assigned to a stream, never to the whole project.": "On est affecté à un stream, jamais au projet entier.",
  "Person": "Personne",
  "Person to assign": "Personne à affecter",
  "Plain text: line breaks are kept.": "Texte simple : les retours à la ligne sont conservés.",
  "Product owners": "Product owners",
  "Project": "Projet",
  "Project closed": "Projet clos",
  "Project not found": "Projet introuvable",
  "Project paused": "Projet en pause",
  "Project reactivated": "Projet réactivé",
  "Project saved": "Projet mis à jour",
  "Project team": "Équipe du projet",
  "Projects": "Projets",
  "Projects created by the DAR will appear here.": "Les projets créés par la DAR apparaîtront ici.",
  "Reactivate the project": "Réactiver le projet",
  "Reactivate “{{title}}”?": "Réactiver « {{title}} » ?",
  "Reactivate…": "Réactiver…",
  "Remove": "Retirer",
  "Remove the minimum TRL": "Retirer le TRL minimum",
  "Remove the search": "Retirer la recherche",
  "Remove {{name}}": "Retirer {{name}}",
  "Remove “My projects”": "Retirer « Mes projets »",
  "Reports": "Comptes rendus",
  "Reports submitted on this project will appear here.": "Les comptes rendus soumis sur ce projet apparaîtront ici.",
  "Request sent": "Demande envoyée",
  "Save": "Enregistrer",
  "Save the links": "Enregistrer les liens",
  "Save the overview": "Enregistrer la présentation",
  "Search for a project": "Rechercher un projet",
  "Search titles and descriptions…": "Rechercher dans les titres et descriptions…",
  "Send the request": "Envoyer la demande",
  "Show more reports": "Afficher plus de comptes rendus",
  "Start date": "Date de début",
  "Status": "Statut",
  "Stream": "Stream",
  "Stream added": "Stream ajouté",
  "Stream archived": "Stream archivé",
  "Stream of link {{number}}": "Stream du lien {{number}}",
  "Stream renamed": "Stream renommé",
  "Stream to join": "Stream à rejoindre",
  "Streams": "Streams",
  "Streams and team": "Streams et équipe",
  "Submitted reports, most recent first.": "Comptes rendus soumis, les plus récents d'abord.",
  "TL/PO saved": "TL/PO enregistrés",
  "Team": "Équipe",
  "Tech leads": "Tech leads",
  "Tech leads and product owners": "Tech leads et product owners",
  "Technologies": "Technologies",
  "Technologies: {{list}}": "Technologies : {{list}}",
  "Technology": "Technologie",
  "The DAR will handle it; the project's TL/PO have been notified.": "La DAR la traitera ; les TL/PO du projet sont prévenus.",
  "The DAR will set the end date of your assignment.": "La DAR fixera la date de fin de votre affectation.",
  "The context, the desired date…": "Le contexte, la date souhaitée…",
  "The project accepts requests to join it again.": "Le projet accepte à nouveau les demandes pour le rejoindre.",
  "The project no longer accepts requests to join it. Assignments carry on and reports remain due.": "Le projet n'accepte plus de nouvelles demandes pour le rejoindre. Les affectations continuent et les CRA restent dus.",
  "The resource allocation office decides and sets the effective date.": "La direction de l'allocation des ressources décide et fixe la date d'effet.",
  "The stream disappears from the choices (requests, assignments). Its reports remain available.": "Le stream disparaît des choix (demandes, affectations). Ses comptes rendus restent consultables.",
  "The stream “{{name}}”": "Le stream « {{name}} »",
  "They edit the project's overview, streams and repositories, and are copied on requests.": "Ils éditent la présentation, les streams et les dépôts du projet, et reçoivent les demandes en copie.",
  "This project is closed.": "Ce projet est clos.",
  "This project is closed: it can still be viewed but no longer edited.": "Ce projet est clos : il reste consultable mais n'est plus modifiable.",
  "This project is paused: it does not accept new requests.": "Ce projet est en pause : il n'accepte pas de nouvelles demandes.",
  "Title": "Titre",
  "Title: {{title}}": "Titre : {{title}}",
  "Upcoming": "À venir",
  "Website": "Site web",
  "What you can bring, your availability…": "Ce que vous pouvez apporter, votre disponibilité…",
  "Whole project": "Tout le projet",
  "Widen the filters or clear them.": "Élargissez les filtres ou effacez-les.",
  "You": "Vous",
  "You already have a pending request to join this project.": "Vous avez déjà une demande en attente pour rejoindre ce projet.",
  "You already have a pending request to leave this project.": "Vous avez déjà une demande en attente pour quitter ce projet.",
  "You are already assigned to every active stream of this project.": "Vous êtes déjà affecté(e) à tous les streams actifs de ce projet.",
  "You are not in the assignable population: contact the DAR.": "Vous n'êtes pas dans la population assignable : contactez la DAR.",
  "You join one stream of the project. The resource allocation office decides and sets the effective date.": "On rejoint un stream du projet. La direction de l'allocation des ressources décide et fixe la date d'effet.",
  "Your account is not linked to any Boond person.": "Votre compte n'est relié à aucune personne Boond.",
  "accepted": "acceptée",
  "e.g. Main repository, Kick-off deck, Production": "ex. Dépôt principal, Support de lancement, Production",
  "from {{date}}": "à partir du {{date}}",
  "none": "aucune",
  "of stream “{{name}}”": "du stream « {{name}} »",
  "refused": "refusée",
  "since {{date}}": "depuis le {{date}}",
  "since {{date}}, until {{end}}": "depuis le {{date}}, jusqu'au {{end}}",
  "stream “{{name}}”": "stream « {{name}} »",
  "the assignment of {{name}}": "l'affectation de {{name}}",
  "the link {{url}}": "le lien {{url}}",
  "the whole project": "tout le projet",
  "until {{date}}": "jusqu'au {{date}}",
  "{{assignments}}, {{requests}}.": "{{assignments}}, {{requests}}.",
  "{{count}} archived streams_one": "{{count}} stream archivé",
  "{{count}} archived streams_other": "{{count}} streams archivés",
  "{{count}} assignments ended_one": "{{count}} affectation terminée",
  "{{count}} assignments ended_other": "{{count}} affectations terminées",
  "{{count}} members_one": "{{count}} membre",
  "{{count}} members_other": "{{count}} membres",
  "{{count}} people_one": "{{count}} personne",
  "{{count}} people_other": "{{count}} personnes",
  "{{count}} projects_one": "{{count}} projet",
  "{{count}} projects_other": "{{count}} projets",
  "{{count}} requests cancelled_one": "{{count}} demande annulée",
  "{{count}} requests cancelled_other": "{{count}} demandes annulées",
  "{{count}} streams_one": "{{count}} stream",
  "{{count}} streams_other": "{{count}} streams",
  "{{name}} leaves {{stream}} on {{date}}.": "{{name}} quitte {{stream}} le {{date}}.",
  "{{name}} · stream “{{stream}}”, since {{date}}.": "{{name}} · stream « {{stream}} », depuis le {{date}}.",
  "{{name}} → {{stream}}, from {{date}}.": "{{name}} → {{stream}}, à partir du {{date}}.",
  "{{name}}: the assignment had not started.": "{{name}} : l'affectation n'avait pas commencé.",
  "{{number}} assignment(s) ended": "{{number}} affectation(s) terminée(s)",
  "{{number}} current or upcoming assignment(s): the DAR must end them first.": "{{number}} affectation(s) en cours ou à venir : la DAR doit d'abord les clore.",
  "{{number}} request(s) cancelled": "{{number}} demande(s) annulée(s)",
  "{{number}} upcoming": "{{number}} à venir",
  "{{title}} (archived)": "{{title}} (archivé)",
  "“{{text}}”": "« {{text}} »"
}
